/**
 * Auth service — the only place the frontend talks to auth endpoints.
 * Sessions are HttpOnly cookies; no tokens are ever stored in JS/localStorage.
 */
import { apiClient } from "@/lib/apiClient";

export const authService = {
  async register(payload) {
    const { data } = await apiClient.post("/auth/register", payload);
    return data;
  },
  async login(email, password) {
    const { data } = await apiClient.post("/auth/login", { email, password });
    return data;
  },
  async logout() {
    const { data } = await apiClient.post("/auth/logout");
    return data;
  },
  async me() {
    const { data } = await apiClient.get("/auth/me");
    return data;
  },
  async verifyEmail(token) {
    const { data } = await apiClient.post("/auth/verify-email", { token });
    return data;
  },
  async forgotPassword(email) {
    const { data } = await apiClient.post("/auth/forgot-password", { email });
    return data;
  },
  async resetPassword(token, password) {
    const { data } = await apiClient.post("/auth/reset-password", { token, password });
    return data;
  },
};
